import React, { useMemo, useState } from 'react';
import ToolLayout from './layout/ToolLayout';
import Card, { CardHeader } from './ui/Card';
import Button from './ui/Button';
import CopyButton from './ui/CopyButton';
import FeedbackMessage from './ui/FeedbackMessage';
import FormField from './ui/FormField';

const Base64Converter = () => {
  const [inputString, setInputString] = useState('');
  const [mode, setMode] = useState('encode');
  const [result, setResult] = useState('');
  const [feedback, setFeedback] = useState({ type: 'info', message: '' });

  const outputTitle = useMemo(() => (mode === 'encode' ? 'Texto codificado' : 'Texto decodificado'), [mode]);

  const handleConvert = () => {
    try {
      const output = mode === 'encode' ? btoa(inputString) : atob(inputString);
      setResult(output);
      setFeedback({ type: 'success', message: `${outputTitle} com sucesso.` });
    } catch (error) {
      setResult('');
      setFeedback({ type: 'error', message: 'Entrada inválida para a operação selecionada.' });
    }
  };

  return (
    <ToolLayout
      title="Base64 Encoder / Decoder"
      description="Converta texto para Base64 e faça o caminho de volta com uma interface consistente."
      category="Encoding & Data"
      note="Processamento local no navegador"
    >
      <div className="tool-grid tool-grid--tool-page">
        <Card>
          <CardHeader title="Entrada" description="Cole o texto ou a string Base64 para converter." />
          <FormField label="Modo">
            <select className="app-select" value={mode} onChange={(e) => setMode(e.target.value)}>
              <option value="encode">Encode para Base64</option>
              <option value="decode">Decode de Base64</option>
            </select>
          </FormField>
          <FormField label="Conteúdo">
            <textarea
              className="app-textarea"
              rows="10"
              value={inputString}
              onChange={(e) => setInputString(e.target.value)}
              placeholder="Digite aqui o conteúdo de entrada"
            />
          </FormField>
          <div className="tool-actions">
            <Button onClick={handleConvert}>Executar</Button>
          </div>
          <FeedbackMessage type={feedback.type}>{feedback.message}</FeedbackMessage>
        </Card>

        <Card>
          <CardHeader title="Resultado" description="Saída pronta para inspeção e cópia." action={<CopyButton value={result} />} />
          <div className="output-panel">
            <span className="output-panel__label">{outputTitle}</span>
            <pre>{result || 'O resultado vai aparecer aqui.'}</pre>
          </div>
        </Card>
      </div>
    </ToolLayout>
  );
};

export default Base64Converter;
